module.exports = __webpack_public_path__ + "static/media/39.5a4d4533.jpg";